import "reflect-metadata"
import { Container } from "inversify"
import SERVICE_IDENTIFIER from "./Identifiers"

import { IAuthService, AuthService } from "../services/security/AuthService"
import { IApiService, ApiService } from "../services/shared/ApiService"
import { IApiServiceExt, ApiServiceExt } from "../services/shared/ApiServiceExt"
import { INotifyService, NotifyService } from "../services/shared/NotifyService"
import { IMenuService, MenuService } from "../services/shared/MenuService"
import { IAppLayoutService, AppLayoutService } from "../services/shared/AppLayout"
import { IAccountService, AccountService } from "../services/AccountService"
import { IStresstestService, StresstestService } from "../services/StresstestService"
import { IClienteAdminService, ClienteAdminService } from "../services/ClienteAdminService"
import { IClienteService, ClienteService } from "../services/ClienteService"
import { IUtenteService, UtenteService } from "../services/UtenteService"
import { IUtenteBackofficeService, UtenteBackofficeService } from "../services/UtenteBackofficeService"
import { IRaccoltaDatiService, RaccoltaDatiService } from "../services/RaccoltaDatiService"
import { IConfigurazioneService, ConfigurazioneService } from "../services/ConfigurazioneService"
import { IUtilityService, UtilityService } from "../services/UtilityService"
import { ILocalStorageService, ISessionStorageService, LocalStorageService, SessionStorageService } from "../services/shared/StorageService"
import { IYapilyService, YapilyService } from "../services/YapilyService"
import { ISupportoService, SupportoService } from "../services/SupportoService"
import { IPianoPrevisionaleService, PianoPrevisionaleService } from "../services/PianoPrevisionaleService"
import { ISignalRServiceHandler, SignalRServiceHandler } from "../services/shared/SignalRServiceHandler"
import { ILicenzeService, LicenzeService } from "../services/LicenzeService"
import { ILicenzaClientiService, LicenzaClientiService } from "../services/LicenzaClientiService"

let container = new Container()

container.bind<IApiService>(SERVICE_IDENTIFIER.API_SERVICE).to(ApiService)
container.bind<IApiServiceExt>(SERVICE_IDENTIFIER.API_SERVICE_EXT).to(ApiServiceExt)
container.bind<IAuthService>(SERVICE_IDENTIFIER.AUTH_SERVICE).to(AuthService)
container.bind<INotifyService>(SERVICE_IDENTIFIER.NOTIFY).to(NotifyService)
container.bind<IMenuService>(SERVICE_IDENTIFIER.MENU_SERVICE).to(MenuService)
container.bind<IAppLayoutService>(SERVICE_IDENTIFIER.APPLAYOUT_SERVICE).to(AppLayoutService)

container.bind<ILocalStorageService>(SERVICE_IDENTIFIER.LOCAL_STORAGE_SERVICE).to(LocalStorageService).inSingletonScope();
container.bind<ISessionStorageService>(SERVICE_IDENTIFIER.SESSION_STORAGE_SERVICE).to(SessionStorageService).inSingletonScope();
container.bind<ISignalRServiceHandler>(SERVICE_IDENTIFIER.SIGNALR).to(SignalRServiceHandler).inSingletonScope();

container.bind<IAccountService>(SERVICE_IDENTIFIER.ACCOUNT_SERVICE).to(AccountService)
container.bind<IUtilityService>(SERVICE_IDENTIFIER.UTILITY_SERVICE).to(UtilityService)
container.bind<IStresstestService>(SERVICE_IDENTIFIER.STRESSTEST_SERVICE).to(StresstestService)
container.bind<IClienteService>(SERVICE_IDENTIFIER.CLIENTE_SERVICE).to(ClienteService)
container.bind<IClienteAdminService>(SERVICE_IDENTIFIER.CLIENTE_ADMIN_SERVICE).to(ClienteAdminService)
container.bind<IUtenteService>(SERVICE_IDENTIFIER.UTENTE_SERVICE).to(UtenteService)
container.bind<IUtenteBackofficeService>(SERVICE_IDENTIFIER.UTENTE_BACKOFFICE_SERVICE).to(UtenteBackofficeService)
container.bind<IRaccoltaDatiService>(SERVICE_IDENTIFIER.RACCOLTA_DATI_SERVICE).to(RaccoltaDatiService)
container.bind<IConfigurazioneService>(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE).to(ConfigurazioneService)
container.bind<IYapilyService>(SERVICE_IDENTIFIER.YAPILY_SERVICE).to(YapilyService)
container.bind<ISupportoService>(SERVICE_IDENTIFIER.SUPPORT_SERVICE).to(SupportoService)
container.bind<IPianoPrevisionaleService>(SERVICE_IDENTIFIER.PIANO_PREVISIONALE).to(PianoPrevisionaleService)
container.bind<ILicenzeService>(SERVICE_IDENTIFIER.LICENZE_SERVICE).to(LicenzeService)
container.bind<ILicenzaClientiService>(SERVICE_IDENTIFIER.LICENZA_CLIENTI_SERVICE).to(LicenzaClientiService)

export default container